<template>
    <div :class="['drawer-landing-city', {'drawer-landing-city-error': areaClassError && !_area.text}]">
        <div class='landing-city' @click="showCity">
            <img-v3 :src="imgUrl" alt="city icon" width="4.5%" class="icon" />
            <div class="title">{{_area && _area.text ? _area.text : title || `${$t('GDriver_optimize_Select_City_kQfI')} >`}}</div>
        </div>
        <single-page-city
            parentCom="landingPage"
            v-if="showPage"
            ref="landingCity"
            @close="closeCity"
            :self-close="true"
            class="landing-page-con"
            :class="{t0:showPage,t100:!showPage}" />
    </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import SinglePageCity from "./singlepage-city.vue";

export default {
    name: "DrawerLandingCity",
    props: {
        imgUrl: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        omegaItem: {
            type: Object,
            default: {}
        },
        areaClassError: {
            type: Boolean,
            default: false
        }
    },
    components: {
        SinglePageCity
    },
    data() {
        return {
            showPage: false,
        }
    },
    computed: {
        ...mapState(["_area", "_uuid"]),
        params() {
            return new URLSearchParams(location.search);
        },
        omegaParams() {
            return  {
                    oid: this.omegaItem.oid,
                    driver_id: this.params.get("uid") || this._uuid + "",
                    location_country_code: this.omegaItem.country,
                    channel: this.omegaItem.channel,
                    end: this.omegaItem.end,
                }
        }
    },
    // 城市动效曝光埋点
    watch:{
        areaClassError(newV, oldV) {
            if(this.areaClassError && !this._area.text) {
                try{
                    Omega.trackEvent("ibt_landingpage_city_circle_sw", "", this.omegaParams);
                }catch(e){}
            }
        },
        _area:  {
            handler(newV, oldV) {
                if(!this._area.text && this.areaClassError) {
                    try{
                        Omega.trackEvent("ibt_landingpage_city_circle_sw", "", this.omegaParams);
                    }catch(e) {}
                }
            },
            deep: true,
        }
    },
    methods: {
        showCity() {
            Omega.trackEvent("ibt_onboarding_landingpagechangecity_ck", "", {
                ...this.omegaItem,
                fbp: this.$cookies.get('_fbp'), // 可选，可能有多个，需要和domain匹配
                fbc: this.$cookies.get('_fbc'), // 可选，可能有多个或没有，需要和domain匹配
            });
            this.showPage = true;
            // @20210604 进入城市列表的时候固定在顶部
            try {
                this.$nextTick(() => {
                    this.$refs.landingCity.$el.scrollIntoView();
                });
            } catch (e) {}
        },
        closeCity() {
            this.showPage = false;
            this.$emit("changeCity");
        }
    }
};
</script>
<style lang="scss">
.drawer-landing-city {
    // display: flex;
    // align-items: center;
    // background: rgba(145, 160, 180, 0.15);
    // border-radius: 0.12rem;
    // padding: 0.43rem 0.4rem;
    .landing-city {
        position: relative;
        display: flex;
        align-items: center;
        padding: 0.43rem 0.4rem;
        background: rgba(145, 160, 180, 0.15);
        border-radius: 0.12rem;
        &::after {
            content: "";
            width: 0.1rem;
            height: 0.1rem;
            border-top: 2px solid;
            border-right: 2px solid;
            border-color: rgb(41, 39, 39);
            border-color: #999;
            position: absolute;
            // top: 0.55rem;
            right: 0.33rem;
            transform: rotate(45deg);
        }
    }
    .landing-page-con {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        // overflow: auto;
        // -webkit-overflow-scrolling: touch;
        background: #fff;
        transition: all 0.4s ease;
        transform: translateX(100%);
    }
    .t0 {
        transform: translateX(0) !important;
    }
    .t100 {
        transform: translateX(100%) !important;
    }
    .icon {
        width: 0.26rem;
        height: 0.36rem;
        margin-right: 0.12rem;
    }
    color: #333333;
    cursor: pointer;
    .landing-page-con .cityList {
        height: 100vh;
        padding-bottom: 2rem;
    }
}
.drawer-landing-city-error {
    border: 1px solid red;
    animation: shake 800ms ease-in-out;
    border-radius: 0.12rem;
}
@keyframes shake {
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(+2px, 0, 0); }
  30%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(+4px, 0, 0); }
  50% { transform: translate3d(-4px, 0, 0); }
}
</style>
